import { Controller } from "@hotwired/stimulus"

// Replica WebsiteEditorSectionItemFormCol.tsx — selector de columnas
// con highlight CUMULATIVO (todas las celdas con value <= seleccionado
// quedan en color activo). Las celdas son divs visuales hermanos de
// radio buttons sr-only; este controller actualiza sus clases en el
// momento del change sin esperar el roundtrip del auto-submit.
//
// HTML esperado:
//   <div data-controller="manage--cumulative-radio">
//     <label>
//       <input type="radio" name="col" value="1" class="sr-only"
//              data-action="change->manage--cumulative-radio#apply">
//       <div data-manage--cumulative-radio-target="cell" data-value="1"></div>
//     </label>
//     ... (1..12)
//   </div>
//
// El server-side render aplica las clases iniciales segun el value
// persistido; este controller solo se encarga de la transicion entre
// click y respuesta del server (UX instantanea).
export default class extends Controller {
  static targets = ["cell"]
  static values = {
    activeClass:   { type: String, default: "bg-[#0477f8]" },
    inactiveClass: { type: String, default: "bg-[#eaeaea]" }
  }

  apply(event) {
    const selected = parseInt(event.target.value, 10)
    if (Number.isNaN(selected)) return

    this.cellTargets.forEach((cell) => {
      const value = parseInt(cell.dataset.value, 10)
      const isActive = value <= selected
      cell.classList.toggle(this.activeClassValue, isActive)
      cell.classList.toggle(this.inactiveClassValue, !isActive)
    })
  }
}
